import {TableCell, TableHead, TableRow, Typography} from "@mui/material";

export const QueryResultsHeaders = (
    {
        date,
        queryHasAtClause,
        headers = [],
    }: {
    date?: string
    queryHasAtClause: boolean,
    headers?: string[],
}) => {
    const defaultHeaders = ['Date', 'Team - Line', 'ATS Δ', 'Opp. - Line', 'Total', 'OU Margin', 'Score']

    return (
        <TableHead>
            <TableRow
                sx={{'& > *': { paddingTop: '4px !important', paddingBottom: '4px !important' },}}
            >
                {(queryHasAtClause ? headers : defaultHeaders)?.map((header: string, ind: number) => {
                    return (
                        <TableCell align="left" key={ind}>
                            <Typography style={{fontWeight: '600'}} variant="caption">
                                {header}
                            </Typography>
                        </TableCell>
                    )
                })}
            </TableRow>
        </TableHead>
    )
}